import { render, staticRenderFns } from "./AdherenceIndicatorsGraph1.vue?vue&type=template&id=35d2a8a7&scoped=true&"
import script from "./AdherenceIndicatorsGraph1.vue?vue&type=script&lang=js&"
export * from "./AdherenceIndicatorsGraph1.vue?vue&type=script&lang=js&"
import style0 from "./AdherenceIndicatorsGraph1.vue?vue&type=style&index=0&id=35d2a8a7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2a8a7",
  null
  
)

export default component.exports